import React, { FC } from 'react'

import {
  getValueListBgColor,
  getValueListContrastColor,
  getValueListHexColor,
} from '../../../../../utils/background-util'
import { setTextAlignment } from '../../../../../utils/text-util'
import {
  setFlexVerticalAlignment,
  setImageBackgroundPosition,
} from '../../../../../utils/layout-util'

import { OverlayDescription } from './OverlayDescription'
import { BannerOverlayProps } from './BannerOverlay.types'
import { sanitizeHTML } from '../../../../../utils/common-utils'

export const BannerOverlay: FC<BannerOverlayProps> = props => {
  const {
    backgroundImage,
    imageDesc,
    imageDescExtraClasses,
    imagePosition,
    imageAltText,
    overlayDescClasses,
    overlayBgColor,
    overlayAlignment,
    overlayTextAlignment,
    overlayHeading,
    overlayDescription,
    bannerId,
    template,
    brandExtension,
  } = props.content

  const templateStyles = () => {
    let name = ''
    switch (template) {
      case 'banner-short':
      case 'banner-short-left-top':
      case 'banner-short-left-center':
      case 'banner-short-left-full':
        name = 'Banner--short'
        break

      case 'banner-tall':
        name = 'Banner--tall'
        break
    }
    return name
  }

  const isPositionLeft = overlayAlignment?.includes('Left')
  const reverseRow = isPositionLeft ? 'u-flexRowReverse' : ''
  const backgroundColor = getValueListHexColor(overlayBgColor || 'white')
  const backgroundGradient = isPositionLeft
    ? `linear-gradient(to right, ${backgroundColor} 50%, transparent 50%)`
    : `linear-gradient(to left, ${backgroundColor} 50%, transparent 50%)`

  return (
    <>
      <style
        type='text/css'
        dangerouslySetInnerHTML={{
          __html: `
      #${bannerId} .BannerOverlayBackground { background: url("${backgroundImage}") no-repeat; }
      `,
        }}
      />

      <section
        className={`FixHeightBannerOverlayComponent ${templateStyles()} ${brandExtension}`}
        id={bannerId}
        data-testid={bannerId}>
        <div
          className={`BannerOverlayBackground u-flex ${setImageBackgroundPosition(
            imagePosition ?? 'contain'
          )} u-bgSizeCover`}>
          <div
            className={`banner-content u-md-flex u-sm-flex ${overlayAlignment}`}
            style={{
              background: templateStyles() === 'Banner--short' ? backgroundGradient : 'transparent',
            }}>
            <div className={`u-sizeConstrained u-flex ${reverseRow}`}>
              <div
                className={`ImageDescription u-flex u-flexAlignItemsEnd ${imageDescExtraClasses} ${
                  isPositionLeft ? 'u-paddingLeft24' : 'u-paddingRight24'
                }`}
                dangerouslySetInnerHTML={{ __html: imageDesc ? sanitizeHTML(imageDesc) : '' }}
              />
              <OverlayDescription
                outerClasses={'u-sm-hidden u-md-hidden'}
                bgColor={getValueListBgColor(overlayBgColor ?? 'white')}
                textColor={getValueListContrastColor(overlayBgColor ?? 'white')}
                alignment={setFlexVerticalAlignment(overlayAlignment ?? 'verticalRightTop')}
                textAlignment={setTextAlignment(overlayTextAlignment ?? 'left')}
                heading={overlayHeading}
                description={overlayDescription}
                descriptionClasses={overlayDescClasses}
                isPositionLeft={isPositionLeft}
              />
            </div>
          </div>
        </div>
        {template === 'auto-height-banner' && (
          <div className='BannerOverlayBackground'>
            <img src={backgroundImage} alt={imageAltText} id={`BannerOverlayBg-${bannerId}`} />
          </div>
        )}

        <OverlayDescription
          outerClasses={'u-lg-hidden'}
          bgColor={getValueListBgColor(overlayBgColor ?? 'white')}
          textColor={getValueListContrastColor(overlayBgColor ?? 'white')}
          alignment={setFlexVerticalAlignment(overlayAlignment ?? 'verticalRightTop')}
          textAlignment={setTextAlignment(overlayTextAlignment ?? 'left')}
          heading={overlayHeading}
          description={overlayDescription}
          descriptionClasses={overlayDescClasses}
        />
      </section>
    </>
  )
}
